import { useNavigate } from "react-router-dom";
import { Minus, Plus, Trash2, ShoppingBag } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { useCart } from "@/context/CartContext";
import { img, tl } from "@/lib/api";

export default function CartSheet() {
  const { items, open, setOpen, setQty, remove, subtotal, unit } = useCart();
  const nav = useNavigate();
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent data-testid="cart-sheet" className="w-full sm:max-w-md flex flex-col p-0">
        <SheetHeader className="p-5 border-b">
          <SheetTitle className="font-display text-xl text-[#172554]">Sepetim</SheetTitle>
          <SheetDescription>{items.length ? `${items.length} çeşit ürün` : "Sepetiniz boş"}</SheetDescription>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto p-5 space-y-4">
          {!items.length && (
            <div className="text-center text-slate-500 py-16">
              <ShoppingBag className="h-12 w-12 mx-auto text-slate-300" />
              <p className="mt-3 text-sm">Henüz ürün eklemediniz.</p>
            </div>
          )}
          {items.map((i) => (
            <div key={i.product_id} data-testid={`cart-item-${i.product_id}`} className="flex gap-3 border-b border-slate-100 pb-4">
              <img src={img(i.image)} alt="" className="h-20 w-20 object-contain rounded border bg-white" />
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold line-clamp-2">{i.name} {i.weight}</div>
                <div className="text-sm font-bold text-[#15803D] mt-1">{tl(unit(i))}</div>
                {i.bulk_price && i.qty >= i.bulk_min_qty && <div className="text-[11px] text-[#172554] font-semibold">Toplu alım indirimi uygulandı</div>}
                <div className="flex items-center gap-2 mt-2">
                  <button data-testid={`cart-minus-${i.product_id}`} onClick={() => setQty(i.product_id, i.qty - 1)} className="h-7 w-7 border rounded flex items-center justify-center"><Minus className="h-3 w-3" /></button>
                  <span className="w-6 text-center text-sm font-bold">{i.qty}</span>
                  <button data-testid={`cart-plus-${i.product_id}`} onClick={() => setQty(i.product_id, i.qty + 1)} className="h-7 w-7 border rounded flex items-center justify-center"><Plus className="h-3 w-3" /></button>
                  <button data-testid={`cart-remove-${i.product_id}`} onClick={() => remove(i.product_id)} className="ml-auto text-slate-400 hover:text-red-600"><Trash2 className="h-4 w-4" /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
        {items.length > 0 && (
          <div className="border-t p-5 space-y-3">
            <div className="flex justify-between font-bold"><span>Ara toplam</span><span data-testid="cart-subtotal">{tl(subtotal)}</span></div>
            <button data-testid="cart-checkout-button" onClick={() => { setOpen(false); nav("/sepet"); }}
              className="w-full h-12 rounded-md bg-[#16A34A] hover:bg-[#15803D] text-white font-bold transition-colors">
              Siparişi Tamamla
            </button>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
